import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './CtaButton';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-391" data-mp="2452tjz75h6ca">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-392" data-mp="294xhbtvmpft4">
          <div className="mx-auto max-w-md" data-id="element-393" data-mp="3ey1t1mdlw611">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-white/30 bg-cta px-4 py-4 font-display text-base font-extrabold uppercase text-white shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:bg-cta-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/60 sm:text-lg" data-id="element-394" data-mp="3ex0cx3hqgtcg">
              <span data-id="element-395" data-mp="1jf782e569uw">Get Instant Access — $27</span>
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-396" data-mp="3sxb98m1tb050" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}